const Content = {
  'people': {
    'title': 'Our People',
    'body': 'From bringing our clients’ stories to life, to constantly deepening our connection to the consumer, our team cultivates the brightest minds in entertainment and tech.'
  }
};

export { Content };
